import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const WitnessUpdate = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.witness_update"
    }), "\xA0", linkToAccount(op[1].witness_account));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.witness_update",
      keys: [{
        type: "account",
        value: op[1].witness_account,
        arg: "account"
      }]
    }));
  }
};